import { FirestoreUser, FirestoreUserRole } from 'generated/graphql';
import { UserProps } from '@/operator/utils/forms/BasicForm';
import { createContext } from 'react';

export type EditUserContextType = {
    loading: boolean;
    selectedRole: FirestoreUserRole;
    fetchedQualityUser: Partial<FirestoreUser>;
    setSelectedRole: React.Dispatch<React.SetStateAction<FirestoreUserRole>>;
    updateUserRole: () => void;
    enableButtons: boolean;
    localUpdatedUser: UserProps;
    setLocalUpdatedUser: React.Dispatch<React.SetStateAction<UserProps>>;
    updateUserBasicInformation: () => Promise<void>;
};

const EditUserContext = createContext<EditUserContextType>({
    loading: false,
    selectedRole: null,
    fetchedQualityUser: null,
    setSelectedRole: () => null,
    updateUserRole: () => null,
    enableButtons: false,
    localUpdatedUser: null,
    setLocalUpdatedUser: () => null,
    updateUserBasicInformation: () => null,
});

export default EditUserContext;
